import { NavLink, Outlet, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { BrandMark, Button, ThemeToggle } from '@clari/ui'
import { LanguageSwitcher } from '@/components/LanguageSwitcher'
import { authApi } from '@/lib/admin-api'
import { useAuthStore } from '@/stores/authStore'

export function AdminLayout() {
  const { t } = useTranslation('admin')
  const navigate = useNavigate()
  const refreshToken = useAuthStore((s) => s.refreshToken)
  const clear = useAuthStore((s) => s.clear)

  async function signOut() {
    try {
      await authApi.logout(refreshToken ?? undefined)
    } catch {
      /* drop local session regardless */
    }
    clear()
    navigate('/login', { replace: true })
  }

  const items = [
    { to: '/users', label: t('nav.users') },
    { to: '/accounts', label: t('nav.accounts') },
    { to: '/transactions', label: t('nav.transactions') },
    { to: '/fx-conversions', label: t('nav.fx_conversions') },
    { to: '/reviews', label: t('nav.reviews') },
    { to: '/risk-assessments', label: t('nav.risk_assessments') },
    { to: '/security', label: t('nav.security') },
    { to: '/kyc', label: t('nav.kyc') },
    { to: '/audit-logs', label: t('nav.audit_logs') },
    { to: '/webhooks', label: t('nav.webhooks') },
    { to: '/business-model', label: t('nav.business_model') },
  ]

  return (
    <div className="flex min-h-screen flex-col bg-bg text-text">
      <header className="flex items-center justify-between border-b border-border px-4 py-3 sm:px-6">
        <BrandMark size={20} />
        <div className="flex items-center gap-2">
          <LanguageSwitcher />
          <ThemeToggle defaultMode="dark" />
          <Button variant="secondary" size="sm" onClick={signOut}>
            {t('nav.sign_out')}
          </Button>
        </div>
      </header>
      <div className="flex flex-1">
        <nav className="w-56 shrink-0 border-r border-border p-4">
          <ul className="flex flex-col gap-1">
            {items.map((item) => (
              <li key={item.to}>
                <NavLink
                  to={item.to}
                  className={({ isActive }) =>
                    [
                      'block rounded-md px-3 py-2 text-sm font-medium transition-colors',
                      isActive ? 'bg-bg-subtle text-text' : 'text-text-muted hover:text-text',
                    ].join(' ')
                  }
                >
                  {item.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>
        <main className="flex-1 p-4 sm:p-8">
          <Outlet />
        </main>
      </div>
    </div>
  )
}
